<template>
  <v-card class="line-card" variant="flat">
    <v-card-text class="pa-4">
      <div class="d-flex align-center justify-space-between mb-1">
        <div class="num">📞 {{ item.msisdn || item.number || '—' }}</div>
        <v-chip :color="onSim ? 'success' : 'warning'" size="small" variant="flat">
          {{ onSim ? c.active : c.in_air }}
        </v-chip>
      </div>

      <div class="sub">
        <template v-if="onSim">{{ c.on_sim }}: {{ simLabel }}</template>
        <template v-else>{{ networkLabel }}</template>
      </div>

      <div class="wallet" v-if="hasWallet">
        <span v-if="item.credit != null">{{ c.credit }} {{ item.credit }} RON</span>
        <span v-if="item.validity_until"> · {{ c.valid_until }} {{ item.validity_until }}</span>
      </div>
      <div class="svc" v-if="servicesList.length">{{ c.services }}: {{ servicesList.join(' · ') }}</div>

      <div class="actions">
        <v-btn size="small" color="primary" variant="tonal" disabled>{{ c.topup }}</v-btn>
        <v-btn size="small" color="secondary" variant="tonal" disabled>{{ c.add_service }}</v-btn>
        <v-btn size="small" variant="text" disabled>{{ onSim ? c.move_to_sim : c.activate_on_sim }}</v-btn>
        <v-chip size="x-small" color="warning" variant="tonal" class="ml-auto">{{ c.soon }}</v-chip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { defineComponent } from 'vue';
import { cc } from "@/views/client/clientCopy";

export default defineComponent({
  name: 'NumberCard',
  props: { item: { type: Object, required: true } },
  computed: {
    c() { return cc(); },
    onSim() { return !!(this.item.current_sim || this.item.sim_label || this.item.sim_id); },
    simLabel() { return this.item.sim_label || this.item.current_sim || ('····' + String(this.item.sim_serial || '').slice(-3)); },
    networkLabel() { return this.item.mvno_name ? this.item.mvno_name : this.c.in_air; },
    hasWallet() { return this.item.credit != null || this.item.validity_until; },
    servicesList() {
      const s = this.item.services;
      if (Array.isArray(s)) return s.map(x => (typeof x === 'string' ? x : (x.name || x.label))).filter(Boolean);
      return [];
    },
  },
});
</script>

<style scoped>
.line-card { border: 1px solid #E6E9F0; border-radius: 16px; box-shadow: 0 1px 3px rgba(20,30,60,.06); }
.num { font-size: 1.15rem; font-weight: 800; color: #1a2233; letter-spacing: .5px; }
.sub { color: #5A6275; font-size: .9rem; }
.wallet { margin-top: 6px; font-weight: 600; color: #1a2233; font-size: .92rem; }
.svc { color: #5A6275; font-size: .88rem; margin-top: 2px; }
.actions { display: flex; align-items: center; gap: 8px; margin-top: 14px; flex-wrap: wrap; }
</style>
